<div class="row w-100 pt-3 text-center row-title">
    <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">Annuler la commande de la carte SIM/eSIM</div>
    <div class="col-12 w-100">
        <div class="w-100 pt-3">
            Je souhaite annuler la commande de ma carte SIM/eSim.
            <br>
            <div class="w-100 pt-3 text-center cta_container">
                <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
                <button type="button" class="cta_btn level_2 column" (click)="confirmation()">Valider<span></span></button>
            </div>
        </div>
    </div>
</div>
